import React, { ComponentProps, PropsWithChildren } from 'react';
import { Tabs as AntTabs } from 'antd';

type AntdPaneProps = ComponentProps<typeof AntTabs.TabPane>;

export const Pane = ({ tab, ...props }: PropsWithChildren<AntdPaneProps>) => {
  // whatever you do with `tab` here will be ignored.

  return <AntTabs.TabPane {...props} />;
};
